import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";

const endpoint = "Venue";
const json = { "Content-Type": "application/json" };
const url = (path: string) => `${environment.server.apiURL}/${endpoint}${path}`;

/** Venues and their seating: chart → area → block → seat. */
export const VenueService = {
	endpoint,
	status: async () => await FetchInterceptor(url("/Status"), {headers: json, method: "GET"}),

	getAll: async () => await FetchInterceptor(url(""), {headers: json, method: "GET"}),
	add: async (data: any) => await FetchInterceptor(url(""), {body: JSON.stringify(data), headers: json, method: "POST"}),
	update: async (id: number, data: any) => await FetchInterceptor(url(`/${id}`), {body: JSON.stringify(data), headers: json, method: "POST"}),
	remove: async (id: number) => await FetchInterceptor(url(`/${id}`), {headers: json, method: "DELETE"}),

	getCharts: async (venueId: number) => await FetchInterceptor(url(`/${venueId}/Charts`), {headers: json, method: "GET"}),
	addChart: async (venueId: number, data: any) => await FetchInterceptor(url(`/${venueId}/Charts`), {body: JSON.stringify(data), headers: json, method: "POST"}),
	/** Copy a whole chart into a new season — how a club realistically sets up next year. */
	cloneChart: async (chartId: number, data: any) => await FetchInterceptor(url(`/Charts/${chartId}/Clone`), {body: JSON.stringify(data), headers: json, method: "POST"}),

	getAreas: async (chartId: number) => await FetchInterceptor(url(`/Charts/${chartId}/Areas`), {headers: json, method: "GET"}),
	addArea: async (chartId: number, data: any) => await FetchInterceptor(url(`/Charts/${chartId}/Areas`), {body: JSON.stringify(data), headers: json, method: "POST"}),
	updateArea: async (id: number, data: any) => await FetchInterceptor(url(`/Areas/${id}`), {body: JSON.stringify(data), headers: json, method: "POST"}),
	removeArea: async (id: number) => await FetchInterceptor(url(`/Areas/${id}`), {headers: json, method: "DELETE"}),

	addBlock: async (areaId: number, data: any) => await FetchInterceptor(url(`/Areas/${areaId}/Blocks`), {body: JSON.stringify(data), headers: json, method: "POST"}),
	removeBlock: async (id: number) => await FetchInterceptor(url(`/Blocks/${id}`), {headers: json, method: "DELETE"}),

	getSeats: async (blockId: number) => await FetchInterceptor(url(`/Blocks/${blockId}/Seats`), {headers: json, method: "GET"}),
	generateSeats: async (blockId: number, data: any) => await FetchInterceptor(url(`/Blocks/${blockId}/GenerateSeats`), {body: JSON.stringify(data), headers: json, method: "POST"}),
	updateSeat: async (id: number, data: any) => await FetchInterceptor(url(`/Seats/${id}`), {body: JSON.stringify(data), headers: json, method: "POST"})
}
